import React from "react";

import "@tennr/style/index.css";
import "./PressPage.css";

// Universal
import { MetadataTags } from "@tennr/frontend/components/MetadataTags";
import { PageBackground } from "@tennr/frontend/components/PageBackground";
import { SiteFooter } from "@tennr/frontend/components/SiteFooter";
import { Link } from "@tanstack/react-router";

import { HeroSection } from "@tennr/frontend/sections/HeroSection";
import { Heading } from "@tennr/frontend/components/Heading";

import { ContentGrid } from "@tennr/frontend/components/ContentGrid";
import { PressItem } from "@tennr/frontend/components/PressItem";
import { Button } from "@tennr/frontend/components/Button";


const cards: any[] = [
  {
      title: "Exclusive: Health tech startup Tennr raises $101 million at $605 million valuation to fix the patient referral process — Fortune",
      url: "https://fortune.com/2025/06/18/tennr-health-tech-ai-patient-referral-ivp-a16z-lightspeed-iconiq-series-c/",
      cta: "Read More",
  },
  {
    title: "Tennr Sees Adoption Accelerating - HME News",
    url: "https://www.hmenews.com/article/tennr-sees-adoption-accelerating",
    cta: "Read More",
  },
  
  {
    title: "Tennr Raises $37 Million In Series B Round To Power New Growth Push — Forbes",
    url: "https://www.forbes.com/sites/davidprosser/2024/10/22/tennr-raises-37-million-in-series-b-round-to-power-new-growth-push/",
    cta: "Read More",
  },

  {
    title: "Tennr’s Deep Dive into HME — HME News",
    url: "https://www.hmenews.com/article/tennr-s-deep-dive-into-hme",
    cta: "Read More",
  },
  
  {
    title: "The Messy Inbox Problem: Wedge Strategies in AI Apps — a16z",
    url: "https://a16z.com/the-messy-inbox-problem-ai-apps-wedge-strategies/",
    cta: "Read More",
  },

  {
    title: "Bill Gates says AI can help solve worker shortages in 2 surprising professions — Business Insider",
    url: "https://www.businessinsider.com/bill-gates-ai-job-shortages-doctors-teachers-work-free-time-2025-4",
    cta: "Read More",
  },
  {
    title: "This AI Startup is trying to make fax machines work better — Bloomberg",
    url: "https://www.bloomberg.com/news/articles/2024-03-26/this-ai-startup-is-trying-to-make-fax-machines-work-better?embedded-checkout=true",
    cta: "Read More",
  }
  
  

];
const releaseCards: any[] = [  
  {
    title: "Reliant Specialty Infusion Partners with Tennr to Scale and Accelerate Patient Access",
    url: "https://www.prnewswire.com/news-releases/reliant-specialty-infusion-partners-with-tennr-to-scale-and-accelerate-patient-access-302429448.html",  
    cta: "Read More",
  },  
  {
    title: "Tennr Launches Workspace and Eligibility & Benefits Management Solutions to Tackle Healthcare's Biggest Administrative Challenges",
    url: "https://www.prnewswire.com/news-releases/tennr-launches-workspace-and-eligibility--benefits-management-solutions-to-tackle-healthcares-biggest-administrative-challenges-302400283.html",
    cta: "Read More",
  },  
  {
    title: "Tennr Hires AJ Kiefer, Former Salesforce Global VP, as Chief Customer Officer",
    url: "https://www.prnewswire.com/news-releases/tennr-hires-aj-kiefer-former-salesforce-global-vp-as-chief-customer-officer-302407289.html",
    cta: "Read More",
  },  
  {
    title: "Tennr Welcomes Bruna Dos Santos as Industry Expert to Drive DME Innovation",
    url: "https://www.prnewswire.com/news-releases/tennr-welcomes-bruna-dos-santos-as-industry-expert-to-drive-dme-innovation-302388682.html",
    cta: "Read More",
  },
];
export const PressPage: React.FC = () => {
  return (
    <>
      <MetadataTags
        title="Press | Tennr"
        description="Read featured coverage about Tennr and find Tennr's logo, brand assets, press kit, and bios."
        imageUrl="https://tennr.com/share_cards/sharecard.png"
      />
      <main className="press-page">
        <PageBackground bgImage="/img/press-hero-bg.jpg" bgImageVert="/img/press-hero-bg-vert.jpg" />
        <HeroSection
          noAnimate={true}
          cmsContent={{
            heading: {
              title: "IN THE NEWS",
              heading: "Press about Tennr",
              body: "Better operations are making headlines.",
            },
          }}
        />
        <section className="press-articles">
          <Heading className="articles-heading" title="Recent Articles" heading="Featured coverage" />
          <ContentGrid className="three-col" gridGap="29px">
            {[...cards].map((card) => (
              <PressItem {...card} />
            ))}
          </ContentGrid>
        </section>
        <section className="press-releases">
          <Heading className="releases-heading" title="Press Releases" heading="Updates from the Team"/>
          <ContentGrid className="three-col" gridGap="29px">
            {[...releaseCards].map((card) => (
              <PressItem {...card} type="release"/>
            ))}
          </ContentGrid>
        </section>
        <section className="press-kit">
          <Heading className="kit-heading" position="center" title="Press Kit" heading="Do you need 
brand assets?" body="Grab logos and bios here."/>
          <Link to="https://info.tennr.com/hubfs/Content/Tennr%20Media%20Kit.pdf" target="_blank">
            <Button text="Download press kit" background="#9B4E45" width={250} height={58} textFromColor="#FBFBF9" />
          </Link>
        </section>
      </main>
      <SiteFooter bgImage="/img/footer-case-study-bg.jpg" bgImageVert="/img/footer-case-study-bg-vert.jpg" />
    </>
  );
};
